import type { PublicOverview } from '../types/api';
import type { SessionUser } from '../stores/session';

const WEEK = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];

const pad = (n: number) => String(n).padStart(2, '0');

export function formatDateTime(value?: string | null): string {
  if (!value) return '待定';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '待定';
  return `${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${WEEK[d.getDay()]} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export function formatDate(value?: string | null): string {
  if (!value) return '';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

/** 首页首屏数字来自接口实际间数，主数据未录时不写死。 */
export function labHeadline(overview?: PublicOverview): string {
  const total = overview?.labs.total ?? 0;
  if (total === 0) return '实验室主数据录入中，可到校参观垂询';
  return `${total} 间实验室已开放预约`;
}

export { WEEK };
export type { SessionUser };
